const rankings = [
  { rank: 1, title: '红桃视频 · 夏日物语', views: '12.5万', change: 'up', tag: '红桃视频' },
  { rank: 2, title: '91视频 · 都市夜话第三季', views: '11.8万', change: 'up', tag: '91视频' },
  { rank: 3, title: '黑桃视频 · 迷雾追踪', views: '10.3万', change: 'new', tag: '黑桃视频' },
  { rank: 4, title: '小蓝视频 · 经典修复·青空', views: '9.6万', change: 'up', tag: '小蓝视频' },
  { rank: 5, title: '97视频 · 逆光之城', views: '8.9万', change: 'down', tag: '97视频' },
  { rank: 6, title: '久久视频 · 岁月如歌合辑', views: '7.4万', change: 'up', tag: '久久视频' },
];

export default function RankingSection() {
  return (
    <section id="ranking" className="relative py-14 md:py-20 bg-background-900/60">
      <div className="max-w-[1400px] mx-auto px-4 md:px-6">
        <div className="text-center mb-10">
          <p className="text-xs md:text-sm text-accent-400 font-medium tracking-wider uppercase mb-2">Ranking</p>
          <h2 className="text-2xl md:text-3xl lg:text-4xl font-heading text-foreground-50 tracking-wide">热度榜单</h2>
          <p className="mt-3 text-sm text-foreground-500 max-w-lg mx-auto">妖精视频本周数字颜色系列人气排行，看看大家都在看什么</p>
        </div>

        <div className="max-w-3xl mx-auto">
          <div className="bg-background-800/40 border border-background-700/30 rounded-lg overflow-hidden">
            {rankings.map((item) => (
              <div
                key={item.rank}
                className="flex items-center gap-3 md:gap-4 p-4 md:p-5 border-b border-background-700/30 last:border-b-0 hover:bg-background-700/30 transition-colors duration-200 cursor-pointer"
              >
                <div className={`w-8 h-8 flex items-center justify-center rounded-lg font-bold text-sm shrink-0 ${
                  item.rank === 1 ? 'bg-accent-500/20 text-accent-400' :
                  item.rank === 2 ? 'bg-secondary-500/15 text-secondary-400' :
                  item.rank === 3 ? 'bg-primary-500/15 text-primary-400' :
                  'bg-background-600/30 text-foreground-600'
                }`}>
                  {item.rank}
                </div>

                <div className="flex-1 min-w-0">
                  <div className="flex items-center gap-2">
                    <h3 className="text-sm md:text-base font-medium text-foreground-200 truncate">{item.title}</h3>
                    {item.change === 'new' && (
                      <span className="text-[10px] px-1.5 py-0.5 rounded bg-primary-500/20 text-primary-400 whitespace-nowrap">NEW</span>
                    )}
                  </div>
                  <p className="text-xs text-foreground-600 mt-0.5 flex items-center gap-1">
                    <i className="ri-eye-line text-[10px]"></i>
                    {item.views} 次观看
                  </p>
                </div>

                <span className="text-xs px-2 py-1 rounded-full bg-accent-500/10 text-accent-400 whitespace-nowrap shrink-0">{item.tag}</span>

                <div className="shrink-0">
                  {item.change === 'up' && <i className="ri-arrow-up-line text-accent-400 text-sm"></i>}
                  {item.change === 'down' && <i className="ri-arrow-down-line text-foreground-600 text-sm"></i>}
                  {item.change === 'new' && <i className="ri-sparkling-line text-primary-400 text-sm"></i>}
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}